import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { t } from 'i18next';
import { YsdkContext } from '../../yandex-add/YsdkProvider';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background-color: black;
  opacity: 85%;
  z-index: 100;
  transition: linear opacity 0.2ms;
  display: flex;
  justify-content: center;
  align-items: center;


  & > span {
    color: white;
    font-size: 4vh;
  }
`;

const COUNTDOWN_TIME_VALUE = 3;

const FullScreenAd = ({ callback }: any) => {
	const ysdk = useContext(YsdkContext);
	const [countdown, setCountdown] = useState(COUNTDOWN_TIME_VALUE);

	useEffect(() => {
		const timer = setTimeout(() => {
			if (countdown > 1) {
				setCountdown(countdown - 1);
			} else {
				clearTimeout(timer);
				showFullScreenAd();
			}
		}, 1000);

		return (): void => {
			clearTimeout(timer);
		};
	}, [countdown]);

	const showFullScreenAd = (): void => {
		// @ts-ignore
		ysdk.adv.showFullscreenAdv(
			{
				callbacks: {
					onOpen: () => {
						console.log('OPEN');
					},
					onClose: (wasShown: boolean) => {
						console.log('CLOSE');
						callback(false);
					},
					onError: () => {
						console.log('ERROR');
						callback(false);
					},
				}
			}
		);
	};

	return (
		<Wrapper>
			<span>{t('FullScreenAdInfo')} {countdown}</span>
		</Wrapper>
	);
};

export default FullScreenAd;